import * as Yup from 'yup';
import { InvoiceFileTypes } from 'store/invoices/types';

export const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email.').required('Email is required.').nullable(),
    [InvoiceFileTypes.COMMERCIAL_INVOICE]: Yup.string().nullable(),
    [InvoiceFileTypes.CUSTOMS_INVOICE]: Yup.string().required('Customs invoice is required.').nullable(),
    [InvoiceFileTypes.SAD]: Yup.string().required('SAD is required.').nullable(),
});
